import action from 'app/lib/action';
import {HTTP_ERROR_401} from '../constants/actionTypes';

export default {
    http401: (error, failedAction) => action(HTTP_ERROR_401)({error, failedAction})
};